module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/053-ghana-ea589f07c1940276a08464d83e3fa15a.svg";